// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__u4GTa","PrivateArea":"Header_PrivateArea__QAYHP"};